import React from "react";
import { Text } from "@opendoor/bricks-next";
//#region src/AccountForm/AccountFormCinderblocks/ErrorPrompt.tsx
/**
* Custom ErrorPrompt component to replace legacy Bricks ErrorPrompt
*/
var ErrorPrompt = ({ message }) => {
	return /* @__PURE__ */ React.createElement(Text, {
		"data-testid": "error-prompt",
		tag: "span",
		typography: "$bodySmall",
		color: "$contentStateErrorDefault",
		marginTop: "$1dot5x"
	}, message);
};
//#endregion
export { ErrorPrompt };

